/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProductcategoryDropDownGet } from '../fn/product-category/api-productcategory-drop-down-get';
import { ApiProductcategoryDropDownGet$Params } from '../fn/product-category/api-productcategory-drop-down-get';
import { apiProductcategoryGet } from '../fn/product-category/api-productcategory-get';
import { ApiProductcategoryGet$Params } from '../fn/product-category/api-productcategory-get';
import { apiProductcategoryGuidGet } from '../fn/product-category/api-productcategory-guid-get';
import { ApiProductcategoryGuidGet$Params } from '../fn/product-category/api-productcategory-guid-get';
import { apiProductcategoryPost } from '../fn/product-category/api-productcategory-post';
import { ApiProductcategoryPost$Params } from '../fn/product-category/api-productcategory-post';
import { apiProductcategoryPut } from '../fn/product-category/api-productcategory-put';
import { ApiProductcategoryPut$Params } from '../fn/product-category/api-productcategory-put';
import { NotificationMessage } from '../models/notification-message';
import { ProductCategoryDto } from '../models/product-category-dto';
import { ProductDropdown } from '../models/product-dropdown';

@Injectable({ providedIn: 'root' })
export class ProductCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProductcategoryGet()` */
  static readonly ApiProductcategoryGetPath = '/api/productcategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductcategoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductcategoryGet$Response(params?: ApiProductcategoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductCategoryDto>>> {
    return apiProductcategoryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductcategoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductcategoryGet(params?: ApiProductcategoryGet$Params, context?: HttpContext): Observable<Array<ProductCategoryDto>> {
    return this.apiProductcategoryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProductCategoryDto>>): Array<ProductCategoryDto> => r.body)
    );
  }

  /** Path part for operation `apiProductcategoryPut()` */
  static readonly ApiProductcategoryPutPath = '/api/productcategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductcategoryPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductcategoryPut$Response(params?: ApiProductcategoryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiProductcategoryPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductcategoryPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductcategoryPut(params?: ApiProductcategoryPut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiProductcategoryPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiProductcategoryPost()` */
  static readonly ApiProductcategoryPostPath = '/api/productcategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductcategoryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductcategoryPost$Response(params?: ApiProductcategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiProductcategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductcategoryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductcategoryPost(params?: ApiProductcategoryPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiProductcategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiProductcategoryDropDownGet()` */
  static readonly ApiProductcategoryDropDownGetPath = '/api/productcategory/drop-down';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductcategoryDropDownGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductcategoryDropDownGet$Response(params?: ApiProductcategoryDropDownGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductDropdown>>> {
    return apiProductcategoryDropDownGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductcategoryDropDownGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductcategoryDropDownGet(params?: ApiProductcategoryDropDownGet$Params, context?: HttpContext): Observable<Array<ProductDropdown>> {
    return this.apiProductcategoryDropDownGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProductDropdown>>): Array<ProductDropdown> => r.body)
    );
  }

  /** Path part for operation `apiProductcategoryGuidGet()` */
  static readonly ApiProductcategoryGuidGetPath = '/api/productcategory/{guid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductcategoryGuidGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductcategoryGuidGet$Response(params: ApiProductcategoryGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCategoryDto>> {
    return apiProductcategoryGuidGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductcategoryGuidGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductcategoryGuidGet(params: ApiProductcategoryGuidGet$Params, context?: HttpContext): Observable<ProductCategoryDto> {
    return this.apiProductcategoryGuidGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductCategoryDto>): ProductCategoryDto => r.body)
    );
  }

}
